const Content = {
  'services': {
    'title': 'Our Services'
  },
  'expertise': {
    'title': 'Creators and Marketers'
  },
  'network': {
    'offices': {
      'title': 'Our Offices'
    },
    'network': {
      'title': 'Our Network'
    }
  },
  'people': {
    'title': 'Our Values'
  },
  'news': {
    'title': 'Featured News'
  }
};

export { Content };
